import TitularHeader from './TitularHeader';

export default TitularHeader;
